import { WIDA_LEVELS } from './tokens';

export const WIDA_LEVEL_KEYS = WIDA_LEVELS.map((level) => level.key);

export type WidaLevelKey = (typeof WIDA_LEVELS)[number]['key'];

export type DomainLevelCounts = Record<WidaLevelKey, number>;

export interface DomainSegment {
  key: WidaLevelKey;
  label: string;
  color: string;
  count: number;
}

export function buildDomainSegments(counts: DomainLevelCounts): DomainSegment[] {
  return WIDA_LEVELS.map((level) => ({
    key: level.key,
    label: level.label,
    color: level.color,
    count: counts[level.key] ?? 0,
  }));
}
